module.exports = __webpack_public_path__ + "static/fig-06-fc951be93ff039c795e82310c431f71a.png";